import { defaultMdCommands, extraMdCommands } from '@/lib/markdownEditorConfig';
import MDEditor, {
  ContextStore,
  ICommand,
  MDEditorProps,
  PreviewType,
} from '@uiw/react-md-editor';

interface MarkdownEditorProps extends MDEditorProps {
  value?: string;
  onChange?: (
    value?: string,
    event?: React.ChangeEvent<HTMLTextAreaElement>,
    state?: ContextStore
  ) => void;
  commands?: ICommand[];
  extraCommands?: ICommand[];
  preview?: PreviewType;
  colorMode?: 'light' | 'dark';
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  commands = defaultMdCommands,
  extraCommands = extraMdCommands,
  preview = 'edit',
  colorMode = 'light',
  ...props
}) => {
  return (
    <MDEditor
      {...props}
      value={value}
      onChange={onChange}
      commands={commands}
      extraCommands={extraCommands}
      preview={preview}
      data-color-mode={colorMode}
    />
  );
};

export default MarkdownEditor;
